import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquareIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navLinks, site } from '../data/site';
import { smsLink, smsMessages } from '../utils/sms';
export function Footer() {
  return <footer className="bg-ink-950 text-white" data-id="element-47" data-mp="32lrmhejrmzki">
      <div className="mx-auto max-w-shell px-5 py-14 sm:px-8 lg:py-20" data-id="element-48" data-mp="36ooa5jo5xlvb">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-49" data-mp="3uf0md6qfy4rp">
          <div data-id="element-50" data-mp="3uftqdzy0mg65">
            <Logo onDark className="h-36" alt={'Hydrosprings \u2014 chlorine-free swimming pools'} data-id="element-51" data-mp="3ud7iu0b4k0nx" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60" data-id="element-52" data-mp="3ldkcr17ga6oj">
              Hydrosprings installs and services Fusion 44X, the world&rsquo;s
              first 100% chemical-free pool solution &mdash; engineered for
              longevity, wellness and prestige. This is not an upgrade.
              It&rsquo;s a replacement.
            </p>
            <p className="mt-6 text-xs uppercase tracking-[0.18em] text-white/40" data-id="element-53" data-mp="3l9abhd1s8u1s">
              {site.region}
            </p>
          </div>

          <nav aria-label="Footer" data-id="element-54" data-mp="3gc0ftfnsvm5i">
            <h2 className="text-xs uppercase tracking-[0.18em] text-white/40" data-id="element-55" data-mp="3gctnciul2fop">
              Explore
            </h2>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-56" data-mp="3q8wpvptckgc6">
              <li data-id="element-57" data-mp="3q7bvq1ay2zeu">
                <Link to="/" className="text-white/75 transition-colors duration-150 ease-smooth hover:text-white" data-id="element-58" data-mp="3qazrz87rxzx9">
                  Home
                </Link>
              </li>
              {navLinks.map(link => <li key={link.to} data-id="element-59" data-mp="hsa8urqnhblf">
                  <Link to={link.to} className="text-white/75 transition-colors duration-150 ease-smooth hover:text-white" data-id="element-60" data-mp="ctqnasfyy1tl">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-61" data-mp="tvd0pv9a0bgq">
            <h2 className="text-xs uppercase tracking-[0.18em] text-white/40" data-id="element-62" data-mp="tvw6kdlnj9ee">
              Reach us
            </h2>
            <ul className="mt-5 space-y-4 text-sm" data-id="element-63" data-mp="yuzce09ghjnf">
              <li data-id="element-64" data-mp="13tansffeg27r">
                <a href={smsLink(smsMessages.general)} className="inline-flex items-center gap-2.5 text-white transition-colors duration-150 ease-smooth hover:text-aqua-300" data-id="element-65" data-mp="13sr6n0xkphus">
                  <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-66" data-mp="1ckt4crg9ck1d" />
                  Text us
                </a>
              </li>
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-white/40" data-id="element-67" data-mp="1mk1u1843bchx">
              Texting is the fastest way to reach a specialist. Message and data
              rates may apply.
            </p>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6" data-id="element-68" data-mp="3oc6qmwwjaxyz">
          <p className="max-w-3xl text-xs leading-relaxed text-white/40" data-id="element-69" data-mp="3ta86l8ynyh68">
            {site.attribution}
          </p>
          <div className="mt-4 flex flex-col gap-3 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-70" data-mp="2afn76wxgt9sw">
            <p data-id="element-71" data-mp="25nlqmyt9kwx2">
              &copy; {new Date().getFullYear()} Hydrosprings. All rights
              reserved.
            </p>
            <p data-id="element-72" data-mp="21kpf1s25612m">Powered by patented Fusion 44X Hydro-pH-Infusion technology.</p>
          </div>
        </div>
      </div>
    </footer>;
}